<template>
  <div
    ref="content"
    v-lazy-container="{ selector: '.lazy-img' }"
    :class="['detail-content-comp', device.inApp ? 'in-app' : '', gameInfo.alias + '-game-content']"
  >
    <!-- 正文 -->
    <div v-if="detail.type === 19" class="video-content">
      <video controls preload="metadata" :src="detail.video_format.video" :poster="detail.video_format.cover"></video>
    </div>
    <div
      v-if="detail"
      ref="wikiDetailContent"
      :class="['wiki-detail-content', classBase + 'detail-content']"
      v-html="detail.content"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// modules
import handleDetailContent, { replaceVote } from "./detailContent.js";
// plugins
import { throttle } from "@/plugins/util";
import eventBus from "@/plugins/eventBus";
// api
import { apiContentDetail } from "@/api/contentApi";
// detail plugins
import wikiEntryToLink from "../../plugins/wikiEntryToLink";

export default {
  name: "detailContent",
  mixins: [],
  props: {
    contentData: {
      type: Object,
      default: () => null
    }
  },
  model: {},
  components: {},
  data() {
    return {
      handleDetailContent: null,
      detail: {},
      sortItems: {},
      filterItems: {},
      selectItems: [],
      activeSort: null,
      // isShowSecondary: false,
      htmlTem: null
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },

  watch: {},
  created() {
    // 服务端渲染
    if (typeof window === "undefined") {
      this.contentData.content = replaceVote(this.contentData.content, this.contentData.vote_list);
      this.contentData.content = this.contentData.content.replace(/<img /gi, '<img loading="lazy" ');

      this.detail = this.contentData;
    }
  },
  beforeMount() {
    // window.appSetDetailContent = this.appSetDetailContent;
    // window.appSetDetailId = this.appSetDetailId;
  },
  mounted() {
    // 监听历史记录内容切换
    eventBus.$on("setDetailContent", this.setDetailContent);

    // editor文章内容处理
    // eslint-disable-next-line
    this.handleDetailContent = new handleDetailContent(this.$refs.wikiDetailContent, this);

    // 设置内容
    if (this.contentData && this.contentData.id > 0) {
      this.setDetailContent(this.contentData);
    }

    // 在APP内，需要同步webview高度
    if (this.device.inApp) {
      this.$refs.content.addEventListener("DOMSubtreeModified", throttle(this.onChangeDom, 200));
      $(this.$refs.content).on("click", this.onChangeDom());
      const myObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          this.onChangeDom();
        });
      });
      myObserver.observe(this.$refs.content);
    }
  },
  updated() {},
  beforeDestroy() {
    this.detail = {};
    this.handleDetailContent.destroy();
    this.handleDetailContent = null;
    eventBus.$off("setDetailContent", this.setDetailContent);
  },
  destroyed() {},
  methods: {
    async getDetail(id) {
      await apiContentDetail({ id }).then(async res => {
        if (res.code == 0) {
          await this.setDetailContent(res.data);
        }
      });
    },
    // 初始化文章模块
    async setDetailContent(detail) {
      detail.content = this.handleDetailContent.replaceImgSrc(detail.content);
      detail.content = this.handleDetailContent.autoLinks(detail.content);
      detail.content = replaceVote(detail.content, detail.vote_list);
      this.detail = detail;
      await this.$nextTick();
      await this.handleDetailContent.handleCatalog();
      await this.handleDetailContent.handleEleReadOnly();
      this.handleDetailContent.initTableFilter();
      this.handleDetailContent.initTableFixed();
      this.handleDetailContent.handleImgGroup();
      this.handleDetailContent._handleBaTable();
      this.handleDetailContent.hadleTableAutoSize();
      this.handleDetailContent.imgViewShow();
      this.habdleFilterSortList();
      // 将内容为wiki词条的转为链接
      setTimeout(() => {
        if (!["www"].includes(this.alias) && this.detail.entry_auto === 1) {
          wikiEntryToLink(this.$refs.content, this.alias, this.$route.params.id);
        }
      }, 100);
    },
    // 只接受APP传入的id
    appSetDetailId(id) {
      this.getDetail(id);
    },
    // 接受APP传入的数据
    appSetDetailContent(data) {
      data = decodeURIComponent(data);
      this.setDetailContent(JSON.parse(data));
    },
    // 初始化筛选项，排序项分类
    habdleFilterSortList() {
      let { model_list } = this.detail;
      let filterItems = {};
      let sortItems = {};
      if (!model_list) return;
      model_list.forEach(item => {
        let tableData = JSON.parse(item.table_data || "[]");
        $(".mould-table-wrap")
          .filter(`[model-id="${item.id}"]`)
          .attr("data-proptree", item.table_data);
        // console.log(tableData);
        tableData.forEach(item2 => {
          let id = item2.tree.oneTree.id;
          if (item2.typeName == "类型") {
            let arr = filterItems[id] || [];
            // 已有的不添加；
            if (
              !arr
                .map(m => {
                  return m.tree.twoTree.text;
                })
                .includes(item2.tree.twoTree.text)
            ) {
              arr.push(item2);
            }
            filterItems[id] = arr;
          } else if (item2.typeName == "属性") {
            let arr = sortItems[id] || [];
            // 已有的不添加；
            if (
              !arr
                .map(m => {
                  return m.tree.twoTree.id;
                })
                .includes(item2.tree.twoTree.id)
            ) {
              arr.push(item2);
            }
            sortItems[id] = arr;
          }
        });
      });

      this.filterItems = filterItems;
      this.sortItems = sortItems;
    },
    // 设置筛选分类
    onFilterItem(item) {
      let { selectItems } = this;
      if (selectItems.includes(item)) {
        selectItems.splice(selectItems.indexOf(item), 1);
      } else {
        selectItems.push(item);
      }
      this.onModelFilter();
    },
    // 设置排序项
    onSortItem(item) {
      this.activeSort = item;
      this.onModelSort(item.tree.twoTree.id);
    },
    // 处理模块节点筛选
    onModelFilter() {
      let { wikiDetailContent } = this.$refs;
      let $models = Array.from(wikiDetailContent.querySelectorAll(".mould-table-wrap"));
      let arr = this.selectItems.map(item => {
        return item.tree.twoTree.text;
      });
      $models.forEach(model => {
        // 没有筛选项全部展示；
        if (!arr.length) {
          $(model).show();
          return;
        }
        let has = 0;
        arr.forEach(val => {
          has = this.hasFilterVal(model, val) ? ++has : has;
        });
        if (has > 0) {
          $(model).show();
        } else {
          $(model).hide();
        }
      });
    },
    // 处理模块节点排序
    onModelSort(sortId) {
      let { wikiDetailContent } = this.$refs;
      this.sortId = sortId;
      let $models = Array.from(wikiDetailContent.querySelectorAll(".mould-table-wrap"));
      $models.sort(($a, $b) => {
        let a_val = 0;
        let b_val = 0;
        a_val = this.getSortVal($a, sortId);
        b_val = this.getSortVal($b, sortId);
        // 去掉非数字字符
        a_val = a_val.replace(/[^0-9]/gi, "");
        b_val = b_val.replace(/[^0-9]/gi, "");
        return b_val - a_val;
      });
      // console.log($models);
      wikiDetailContent.innerHTML = "";
      $models.forEach($item => {
        wikiDetailContent.appendChild($item);
      });
    },
    // 判模块是否有对应的筛选项
    hasFilterVal($el, val) {
      let has = false;
      let dataProp = this.getDataPorp($el);
      dataProp.forEach(item => {
        if (item.tree && item.tree.twoTree && item.tree.twoTree.text && val == item.tree.twoTree.text) {
          has = true;
        }
      });
      return has;
    },
    // 获取模块排序值
    getSortVal($el, id) {
      let val = 0;
      let dataProp = this.getDataPorp($el);
      dataProp.forEach((item, i) => {
        if (item.tree && item.tree.twoTree && item.tree.twoTree.id && id == item.tree.twoTree.id) {
          val = item.tree.twoTree.val;
        }
      });
      return val;
    },
    getDataPorp($el) {
      let dataProp = $el.dataset.proptree || '{"attr":[],"type":[]}';
      dataProp = JSON.parse(dataProp);
      // 兼容之前数据，先判断是不是数组，不是数组，先转出数组(新数据是数组)；
      if (!(dataProp instanceof Array)) {
        dataProp = [dataProp];
      }
      return dataProp;
    },
    onChangeDom() {
      if (!this.device.inApp) return;
      this.jsToApp("app_listenWebViewHeight", this.$refs.content.clientHeight);
    }
  }
};
</script>
<style></style>
<style lang="less" scoped>
@import url("../../../../../assets/css/detailContent.less");

.in-app {
  //padding: 0 12px;
  background: #fff;
}

.wiki-detail-content {
  min-height: 300px;
  font-size: 14px;
  word-break: break-word;
  line-height: 1.5;
  background: #fff;

  &.wap-detail-content {
    min-height: 100px;
  }
}

.video-content {
  width: 100%;
  margin-bottom: 20px;
  video {
    width: 100%;
    object-fit: cover;
  }
}

.filter-sort-items {
  margin-top: 10px;

  .row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    font-size: 14px;

    .title {
      margin-right: 10px;
      font-weight: bold;
      line-height: 24px;
    }

    > div {
      flex: 1;

      span {
        background: #f5f5f5;
        padding: 0 5px;
        line-height: 24px;
        display: inline-block;
        cursor: pointer;
        color: #666;
        transition: 0.3s;
        user-select: none;

        &:hover {
          background: #bbb;
        }

        &.active {
          background: fade(#94b7e9, 50%);
        }
      }

      span + span {
        margin-left: 10px;
      }
    }
  }
}
</style>
